// API client with httpOnly cookie auth
const API_BASE = process.env.REACT_APP_BACKEND_URL + "/api";

export async function api(path, options = {}) {
  const url = API_BASE + path;
  const opts = {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  };
  if (opts.body && typeof opts.body !== "string") opts.body = JSON.stringify(opts.body);
  const res = await fetch(url, opts);
  let data = null;
  try { data = await res.json(); } catch (e) { /* no body */ }
  if (!res.ok) {
    const detail = data?.detail;
    const msg = formatErr(detail) || res.statusText || "Erreur réseau";
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function apiRaw(path, options = {}) {
  const url = API_BASE + path;
  const opts = {
    credentials: "include",
    headers: { ...(options.headers || {}) },
    ...options,
  };
  const res = await fetch(url, opts);
  if (!res.ok) {
    const err = new Error(res.statusText || "Erreur réseau");
    err.status = res.status;
    throw err;
  }
  return res;
}

export function formatErr(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
